import Phaser from 'phaser';

/**
 * Wire a bg-rect + text-label pair so BOTH objects respond to pointer events.
 *
 * Without this, the common "bgRect + text overlay" button pattern only
 * registers clicks where the text glyphs actually are — the visible padding
 * around the label silently drops clicks. Making the bg rect interactive too
 * gives the whole visual button area a proper hitbox, while keeping the text
 * interactive preserves any existing Phaser-managed hover behaviour when the
 * cursor is over the glyphs themselves.
 *
 * Both objects share a single `onDown` handler, and optionally `onHover`/`onOut`
 * so hover styling stays consistent no matter which object the pointer is on.
 */
export function wireButton(opts: {
  bg: Phaser.GameObjects.Rectangle;
  text: Phaser.GameObjects.Text;
  onDown: () => void;
  onHover?: () => void;
  onOut?: () => void;
}): void {
  const { bg, text, onDown, onHover, onOut } = opts;
  for (const obj of [bg, text] as (Phaser.GameObjects.Rectangle | Phaser.GameObjects.Text)[]) {
    obj.setInteractive({ useHandCursor: true });
    obj.on('pointerdown', onDown);
    if (onHover) obj.on('pointerover', onHover);
    if (onOut) obj.on('pointerout', onOut);
  }
}
